var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRetiroNoReconocido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 34.1,
    r: 1.5,
    fill: "#09C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 36c0-12.7 10.3-23 23-23s23 10.3 23 23-10.3 23-23 23-23-10.3-23-23zm39.4 14.7C55.9 46.8 58 41.6 58 36c0-12.1-9.9-22-22-21.9-5.7 0-10.8 2.1-14.7 5.6l5.2 5.2 11.8-6c.6-.3 1.2-.3 1.7 0s.9.7 1 1.3l.8 3.4 4.3-.9c.7-.1 1.3 0 1.9.4.6.4 1 .9 1.1 1.6l1.1 5.4c.9.3 1.6 1 1.8 1.9l.5 2.2c.2.9-.2 1.8-.9 2.4l1.3 6c.1.7 0 1.3-.4 1.9-.4.6-.9 1-1.6 1.1l-3 .6 4.5 4.5zM27.1 26.9l-3.9.8 3.1-1.6.8.8zm11.7-7.1-11.5 5.8 1.1 1L40.9 24l-.8-3.6c-.1-.3-.3-.5-.5-.6-.3-.1-.6-.1-.8 0zm-18.4 9.5 7.6-1.6 17.9 17.9-21.1 4.5c-.4.1-.8 0-1.1-.2-.3-.2-.6-.6-.6-.9l-3.8-17.8c-.3-.9.3-1.7 1.1-1.9zm26-5.5-17.2 3.6 17.6 17.9 3.7-.8c.3 0 .7-.3.9-.6.2-.3.3-.7.2-1.1L50.4 37h-.1l-7.6 1.6c-.2.1-.3.1-.5.1-1.1 0-2.2-.8-2.4-2l-.4-2.1c-.1-.7 0-1.3.4-1.9.4-.6.9-1 1.6-1.1L49 30h.2l-1.1-5.1c0-.3-.3-.7-.6-.9-.2-.1-.5-.2-.8-.2h-.3zm3.9 12.3-7.6 1.6c-.8.2-1.6-.3-1.8-1.2l-.4-2.1c-.1-.4 0-.8.2-1.1.2-.3.6-.6.9-.6l7.6-1.6h.3c.7 0 1.3.5 1.5 1.2l.4 2.1c.2.7-.3 1.5-1.1 1.7zM14 36c0 12.1 9.9 22 22 22 6.1 0 11.7-2.5 15.8-6.6l-5-5L25 51c-.2.1-.3.1-.5.1-.5 0-1-.1-1.4-.4-.6-.4-1-.9-1.1-1.6l-3.9-17.9c-.2-1.1.4-2.2 1.3-2.7v-.1l6.2-3.1-5-5c-4.1 4-6.6 9.6-6.6 15.7zm46-10.8c-.2 0-.4-.1-.5-.3-2-4.2-5-7.8-8.8-10.4-.2-.2-.3-.5-.1-.7.2-.2.5-.3.7-.1 4 2.7 7.1 6.5 9.2 10.8.1.2 0 .5-.2.7H60zm-.4-6.1c.1.1.2.2.4.2.1 0 .2 0 .3-.1.2-.2.3-.5.1-.7-1.3-1.8-2.8-3.4-4.4-4.9-.2-.2-.5-.2-.7 0-.2.2-.2.5 0 .7 1.6 1.5 3.1 3.1 4.3 4.8z",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetiroNoReconocido);
export default __webpack_public_path__ + "static/media/icon_retiro_no_reconocido.fa33b9b6.svg";
export { ForwardRef as ReactComponent };